import React from 'react';
import DatePicker from '@components/form/DatePicker';
import MultiSelect from '@components/form/MultiSelect';
import { CalendarChallengeGroupDropdownOption } from 'src/types/shared/Challenge';
import Form from '@components/form/Form';
import FormField from 'lib/src/components/form/FormField';

const CalendarFilters: React.FC<CalendarFiltersProps> = ({
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    challengeGroupIDs,
    setChallengeGroupIDs,
    challengeGroupOptions,
    fieldErrors: { startDateError, endDateError, challengeGroupIDsError },
}) => {
    return (
        <>
            <Form onSubmit={() => {}} omitButtons>
                <div className="calendar-filters-title">Show Challenges occurring between:</div>
                <div className="calendar-filters">
                    <FormField name="FilterFrom" error={startDateError}>
                        <DatePicker
                            value={startDate}
                            onChange={(_, value) => setStartDate(value as Date)}
                            name="startDate"
                            disableRemove
                            maxDate={endDate}
                        />
                    </FormField>
                    <div className="calendar-filters-label">and</div>
                    <FormField name="FilterTo" error={endDateError}>
                        <DatePicker
                            value={endDate}
                            onChange={(_, value) => setEndDate(value as Date)}
                            name="endDate"
                            disableRemove
                            minDate={startDate}
                        />
                    </FormField>
                    <div className="calendar-filters-label">for</div>
                    <FormField name="ChallengeGroupIDs" error={challengeGroupIDsError}>
                        <MultiSelect
                            value={challengeGroupIDs}
                            onChange={(_, value) => setChallengeGroupIDs(value as number[])}
                            name="challengeGroupIDs"
                            options={challengeGroupOptions}
                        />
                    </FormField>
                </div>
            </Form>
        </>
    );
};

interface CalendarFiltersProps {
    startDate: Date;
    endDate: Date;
    setStartDate: (date: Date) => void;
    setEndDate: (date: Date) => void;
    challengeGroupIDs: number[];
    setChallengeGroupIDs: (ids: number[]) => void;
    challengeGroupOptions: CalendarChallengeGroupDropdownOption[];
    fieldErrors: { [key: string]: string | null };
}

export default CalendarFilters;
